import { useCreateBlendContext } from "domains/models/contexts/CreateBlendProvider";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
} from "domains/ui/components/Modal";

import { Box, CloseButton, VStack } from "@chakra-ui/react";

import BlendTryOut from "./BlendTryOut";

export default function BlendModalTestConcept() {
  const { isTryOutModalOpen, setIsTryOutModalOpen } = useCreateBlendContext();

  return (
    <Modal
      isOpen={isTryOutModalOpen}
      onClose={() => setIsTryOutModalOpen(false)}
      variant="modern"
    >
      <ModalOverlay />
      <ModalContent
        pos={"relative"}
        overflow={"hidden"}
        w={"90vw"}
        maxW={"1600px"}
        h={"90vh"}
        p={0}
        borderRadius={"2xl"}
      >
        <Box pos="absolute" zIndex="overlay" top={3} right={3}>
          <CloseButton
            color={"textPrimary"}
            onClick={() => setIsTryOutModalOpen(false)}
          />
        </Box>

        <ModalBody w="100%" minH="500px">
          <VStack h="100%" spacing={0}>
            <VStack overflow={"auto"} w="100%" h="100%" spacing={3}>
              <BlendTryOut />
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
